module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-29.2-c8f3c975c9ba1e559b417ff5db3c9fc5.svg";